import { RouteObject } from "react-router-dom";
import { PROFILE, PROFILE_CONTACT, PROFILE_UPDATE } from "constants/urls";

export default [
  {
    index: true,
    path: PROFILE,
    lazy: () => import("modules/profile/pages/Profile"),
  },
  {
    path: PROFILE_CONTACT,
    lazy: () => import("modules/profile/pages/FreelancerContact"),
  },
  {
    path: PROFILE_UPDATE,
    lazy: () => import("modules/profile/pages/ProfileUpdate"),
  },
] as RouteObject[];
